import React from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { BnblPackageDuration } from './BnblPackageDuration'
import { Divider } from './Divider'
import type { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import { BnblPackageImageAndName } from './BnblPackageImageAndName'
import BnblPackageRooms from './BnblPackageRooms'
import Group from 'components/utils/Group'
import { BnblPackagePreviewVariant } from './BnblPackagePreviewVariant'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import { BnblPackageImageAndNameVariant } from './BnblPackageImageAndNameVariant'
import Heading from 'LuxKit/Typography/Heading'

interface MappedProps {
  packageView: App.OfferPackageOptionView
}

interface Props {
  offer: App.Offer
  setStep: (step: BnblSteps) => void
}

function BnblOneRoomPackage(props: Props & MappedProps) {
  const {
    offer,
    packageView,
    setStep,
  } = props
  const { id: offerId, image } = offer
  const { duration, name: packageName, roomType: { name: roomTypeName }, uniqueKey } = packageView.package

  const intl = useIntl()
  const isMobileDevice = useIsMobileDevice()
  const useNewMobileHotelOfferPage = isMobileDevice && offer.type === OFFER_TYPE_HOTEL

  return <Group direction="vertical" gap={16}>
    <Heading variant="heading5">{intl.formatMessage({
      id: '3ECF/Rm7Th',
      defaultMessage: 'Room Details',
      description: 'Heading for the room details section in BNBL one-room package view',
    })}
    </Heading>
    {!useNewMobileHotelOfferPage && <BnblPackageImageAndName
      image={image}
      packageName={packageName}
      roomTypeName={roomTypeName}
    />}
    {useNewMobileHotelOfferPage && (
      <>
        <BnblPackageImageAndNameVariant
          image={image}
          roomTypeName={roomTypeName}
        />
        <Divider />
        <BnblPackagePreviewVariant
          packageName={packageName}
          setStep={setStep}
        />
      </>
    )}
    <Divider />
    <BnblPackageDuration
      duration={duration}
      setStep={setStep}
    />
    <Divider />
    <BnblPackageRooms
      offerId={offerId}
      packageKey={uniqueKey}
    />
  </Group>
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const bnblModalPackages = state.offer.bnblModal[ownProps.offer.id]
  const { packageView } = bnblModalPackages[0]
  return {
    packageView,
  }
}

export default connect(mapStateToProps)(BnblOneRoomPackage)
